import { render, staticRenderFns } from "./BorderRadius.vue?vue&type=template&id=7cd55314&"
import script from "./BorderRadius.vue?vue&type=script&lang=js&"
export * from "./BorderRadius.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports